module.exports = __webpack_public_path__ + "img/49.d6aa4db5.jpg";